import React from "react";
import useEntity from "../../../hooks/useAccountingUser";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./AccountingUserListHeader";
import EntityListSearch from "./AccountingUserListSearch";
import {useLocation} from "react-router";
import AccountingUserListPagination from "./AccountingUserListPagination";
import * as Api from "../../../apis/AccountingUser.api";
import { AccountingUser } from "../../../types/models/AccountingUser";
import { PrimaryAccountingUser } from "../../../types/models/AccountingUser";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { PrimaryUser } from "../../../../auth/types/models/User";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import AccountingUserListItemTools from "./AccountingUserListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    email?: string,
    name?: string,
    userId?: ID,
    };

const AccountingUserListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('AccountingUser')

    
    
    
    
    const [, setSearchInputValue, searchInputTerm] = useSearchDebounce();
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetAccountingUserPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    userIdRefs: (PrimaryUser.fromQuery(query.userId)) ? [ PrimaryUser.fromQuery(query.userId) ] : [],
                    email: searchInputTerm || '',
                    emailOr: true,
                    name: searchInputTerm || '',
                    nameOr: true,
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: AccountingUser) => routeLocation.pathname.endsWith('accounting-users') ?
        `${PrimaryAccountingUser.fromEntity(entity).toPath()}`
        :
        `accounting-users/${PrimaryAccountingUser.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: AccountingUser) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                <EntityListSearch
                    setSearchInputValue={setSearchInputValue}
                    
                    query={query}
                    refetch={refetch}
                />
                <TableContainer>

                    


                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="AccountingUser-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                    

                                    
                            <StyledTableCell align="left">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'name') }
                                    direction={ orderBys.find((item) => item.name === 'name')?.direction || 'asc' }
                                    onClick={() => toggleOrder('name')}
                                >
                                
                                    <Trans>Name</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryAccountingUser.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.name ?
                                        <>
                                            
                        
                        { item.name || '-' }
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>

                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="AccountingUser-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'email') }
                                            direction={ orderBys.find((item) => item.name === 'email')?.direction || 'asc' }
                                            onClick={() => toggleOrder('email')}
                                        >
                                        
                                            <Trans>Email</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'name') }
                                            direction={ orderBys.find((item) => item.name === 'name')?.direction || 'asc' }
                                            onClick={() => toggleOrder('name')}
                                        >
                                        
                                            <Trans>Name</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryAccountingUser.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.email || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.name || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <AccountingUserListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Accounting Users</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <AccountingUserListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default AccountingUserListItem;
